import { red } from "../../theme/colors";

// For MUI fields whose label floats inside the input border (TextField/
// Autocomplete `label` prop) rather than sitting in a separate Typography
// above the field — RequiredMark is for that latter pattern.
export default function RequiredFieldLabel({ label }: { label: string }) {
  return (
    <>
      {label} <span style={{ color: red }}>*</span>
    </>
  );
}
